module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('my-menu', {
    attrs: {
      "menu-name": "junior"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "banner"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": require("../assets/images/czheader2.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "switch"
  }, [_c('router-link', {
    staticClass: "switch-active",
    attrs: {
      "to": "/teachercz"
    }
  }, [_vm._v("教师端")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/junior"
    }
  }, [_vm._v("学生端")])], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "junior_card"
  }, [_c('ul', [_c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz1.png'),
      expression: "'/static/images/cz1.png'"
    }]
  }), _vm._v(" "), _vm._m(4)]), _vm._v(" "), _c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz2.png'),
      expression: "'/static/images/cz2.png'"
    }]
  }), _vm._v(" "), _vm._m(5)]), _vm._v(" "), _c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz3.png'),
      expression: "'/static/images/cz3.png'"
    }]
  }), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('li', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: ('/static/images/cz4.png'),
      expression: "'/static/images/cz4.png'"
    }]
  }), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('my-footer')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner"
  }, [_c('p', {
    staticClass: "text_weici"
  }, [_vm._v("维词•初中生")]), _vm._v(" "), _c('p', {
    staticClass: "text_slogan"
  }, [_vm._v("自主学习词汇APP")]), _vm._v(" "), _c('img', {
    staticClass: "qrcode",
    attrs: {
      "src": require("../assets/images/czqrcode.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text_download"
  }, [_vm._v("扫描下载APP")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download"
  }, [_c('a', {
    attrs: {
      "href": "https://itunes.apple.com/cn/app/%E7%BB%B4%E8%AF%8D%E5%88%9D%E4%B8%AD%E7%89%88/id1228082964?mt=8",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ios.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "http://android.myapp.com/myapp/detail.htm?apkName=com.victorstudy.weici.junior",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/ad.png")
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("维词APP初中版")]), _vm._v(" "), _c('p', [_vm._v("通过语音、词块，中英文差异句的输入")]), _vm._v(" "), _c('p', [_vm._v("有效培养英语学习能力，成为初中词汇学习APP")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/arrow.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("词汇精讲")]), _vm._v(" "), _c('p', [_vm._v("标注适合背诵例句、培养词块学习意识")]), _vm._v(" "), _c('p', [_vm._v("点拨学生易犯错误、突出英汉表达差异")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("同步教材")]), _vm._v(" "), _c('p', [_vm._v("教材单元同步学习")]), _vm._v(" "), _c('p', [_vm._v("备考分级学习，同步课堂学习计划")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("紧扣教学")]), _vm._v(" "), _c('p', [_vm._v("标注单词词频、精选例句、自由订制学习计划")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "junior_label"
  }, [_c('p', [_vm._v("真人离线发声")]), _vm._v(" "), _c('p', [_vm._v("真人离线无延迟、精选词块、例句朗读、跟读")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-07f36f74","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Junior.vue
// module id = 81
// module chunks = 0